import { Component, EventEmitter, Output, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ButtonSize,
  ButtonState,
  ButtonType,
  IEducation, IUser,
  IWorkExperience, MaterialType,
} from '../../../../../../assets/types/dtoTypes';
import { RegistrationPageService } from '../../registration-page.service';
import { CvResultModalComponent } from '../../../../../modals/cv-result-modal/cv-result-modal.component';
import {
  ParsingLoadingModalComponent,
} from '../../../../../modals/parsing-loading-modal/parsing-loading-modal.component';
import { ImageService } from '../../../../../shared/services/image.service';
import { AuthenticationService } from '../../../../../shared/services/authentication.service';
import {UploadFormComponent} from "../../../../../shared/upload-form/upload-form.component";
import {TranslateModule} from "@ngx-translate/core";
import {ButtonComponent} from "../../../../../shared/button/button.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-resume-form',
  templateUrl: './resume-form.component.html',
  styleUrls: ['./resume-form.component.scss'],
  imports: [
    UploadFormComponent,
    TranslateModule,
    ButtonComponent,
    NgIf
  ],
  standalone: true
})
export class ResumeFormComponent {
  private registrationPageService = inject(RegistrationPageService);
  private imageService = inject(ImageService);
  private authService = inject(AuthenticationService);
  dialog = inject(MatDialog);


  @Output() cvParsedData = new EventEmitter<{
    education: IEducation[],
    workExperience: IWorkExperience[],
    skills: string[]
  }>();

  isLoading = false;

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonType = ButtonType;

  loadingDialogRef: any;

  profileImage: string;

  constructor() {
    const formData = inject<string>('formData' as any);

    this.profileImage = formData;
    this.imageService.appendSasTokenToProfileImageUrl( this.profileImage, this.authService.getIdFromAccessToken() ).toPromise().then( ( url ) => {
      this.profileImage = url;
    } );
  }


  displayModal() {
    this.loadingDialogRef = this.dialog.open( ParsingLoadingModalComponent, {
      width: '100%',
      maxWidth: '600px',
      panelClass: 'cv-modal-panel',
      disableClose: true,
    } );
  }

  sendUploadedFile( $event ) {
    this.registrationPageService.parseCV( $event ).subscribe( ( result ) => {
      if ( this.loadingDialogRef ) {
        this.loadingDialogRef.close();
      }

      const resultDialogRef = this.dialog.open( CvResultModalComponent, {
        width: '100%',
        maxWidth: '600px',
        disableClose: true,
        height: '90vh',
        panelClass: 'cv-modal-panel',
        data: {
          ...result,
          profileImage: this.profileImage,
        },
      } );

      resultDialogRef.afterClosed().subscribe( ( parsedCV: Partial<IUser> ) => {
        if ( parsedCV ) {
          this.registrationPageService.sendParsedResume( {
            cvUrl: $event,
            motivation: parsedCV.motivation,
            education: parsedCV.education,
            workExperience: parsedCV.workExperience,
            languages: parsedCV.languages,
          } );
          this.registrationPageService.openForm( 'resume_form_continue' );
        }
      } );
    } );
  }

  back() {
    this.registrationPageService.openForm( 'resume_form_back' );
  }

  skip() {
    this.registrationPageService.sendParsedResume( {
      cvUrl: null,
      motivation: null,
      education: null,
      workExperience: null,
      languages: null,
    } );
    this.registrationPageService.openForm( 'resume_form_continue' );
  }

  protected readonly MaterialType = MaterialType;
}
